import React, { useEffect, useState } from 'react'
import DatosTransferenciaVnzla from './cuentas_retiro/DatosTransferenciaVnzla';
import DatosTransferencia from './cuentas_retiro/DatosTransferencia';
import DatosPagoMovil from './cuentas_retiro/DatosPagoMovil';
import DatosNequi from './cuentas_retiro/DatosNequi';
import DatosOtrosCol from './cuentas_retiro/DatosOtrosCol';
import DatosBizum from './cuentas_retiro/DatosBizum';
import CuentasOnline from './cuentas_retiro/CuentasOnline';
import DatosUsdtBinance from './cuentas_retiro/DatosUsdtBinance';
import DatosUsdtBilletera from './cuentas_retiro/DatosUsdtBilletera';
import DatosOxxo from './cuentas_retiro/DatosOxxo';

const DatosRetiro = ({tipoOperacion, form, setForm, handleChange, clearForm}) => {

  const [moneda, setMoneda] = useState('');
  const [tipo, setTipo] = useState('');

  useEffect(()=>{
    clearForm();
    const arr = tipoOperacion.split('-');
    setTipo(arr[0].toLowerCase());
    setMoneda(arr[1].toLowerCase());
  },[tipoOperacion])

  return (
    <>
      {/* BS.S */}
      {(moneda==='bs.s' && tipo==='transferencia') && <DatosTransferenciaVnzla form={form} setForm={setForm} handleChange={handleChange}/>}
      {(moneda==='bs.s' && tipo==='pago movil') && <DatosPagoMovil form={form} setForm={setForm} handleChange={handleChange}/>}
      {/* COP */}
      {(moneda==='cop' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='col'/>}
      {(moneda==='cop' && tipo==='nequi') && <DatosNequi form={form} setForm={setForm} handleChange={handleChange}/>}
      {(moneda==='cop' && tipo==='otros') && <DatosOtrosCol form={form} setForm={setForm} handleChange={handleChange}/>}
      {/* SOL */}
      {(moneda==='sol' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='peru'/>}
      {(moneda==='sol' && (tipo==='yape' || tipo==='plin')) && <DatosNequi form={form} setForm={setForm} handleChange={handleChange}/>}
      {(moneda==='eur' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='eur'/>}
      {/* EUR */}
      {(moneda==='eur' && tipo==='bizum') && <DatosBizum form={form} setForm={setForm} handleChange={handleChange}/>}
      {/* CLP */}
      {(moneda==='clp' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='chile'/>}
      {/* ARS */}
      {(moneda==='ars' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='arg'/>}
      {/* DOP */}
      {(moneda==='dop' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='do'/>}
      {/* $ */}
      {(moneda==='$' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='usa'/>}
      {(moneda==='$' && tipo==='paypal') && <CuentasOnline form={form} setForm={setForm} handleChange={handleChange} cuenta='PAYPAL' />}
      {(moneda==='$' && tipo==='zelle') && <CuentasOnline form={form} setForm={setForm} handleChange={handleChange} cuenta='ZELLE' />}
      {(moneda==='$' && tipo==='zinli') && <CuentasOnline form={form} setForm={setForm} handleChange={handleChange} cuenta='ZINLI' />}
      {(moneda==='$' && tipo==='yappy') && <CuentasOnline form={form} setForm={setForm} handleChange={handleChange} cuenta='YAPPY' />}
      {(moneda==='$' && tipo==='nequi') && <DatosNequi form={form} setForm={setForm} handleChange={handleChange}/>}
      {(moneda==='$' && tipo==='usdt (binance pay)') && <DatosUsdtBinance form={form} setForm={setForm} handleChange={handleChange}/>}
      {(moneda==='$' && tipo==='usdt (billetera)') && <DatosUsdtBilletera form={form} setForm={setForm} handleChange={handleChange}/>}
      {/* MXN */}
      {(moneda==='mxn' && tipo==='oxxo') && <DatosOxxo form={form} setForm={setForm} handleChange={handleChange}/>}
      {(moneda==='mxn' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='mexico' />}

      {/* GTQ */}     
      {(moneda==='gtq' && tipo==='transferencia') && <DatosTransferencia form={form} setForm={setForm} handleChange={handleChange} pais='guatemala' />}
    </>
  )
}

export default DatosRetiro